"use client";
import { useState } from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import InputMask from "react-number-format";

import styles from "./styles.module.css";

const Input = ({ inputClass, errorMessage, password, showHideButton, phone, value, onChange, onKeyDown, ...props }) => {
  const [passwordType, setPasswordType] = useState(password && "password");

  const inputClasses = classNames({
    [styles.input]: true,
    [styles.error]: errorMessage,
    [styles.passwordInput]: password,
    [inputClass]: inputClass,
  });

  const showHide = (e) => {
    e.preventDefault();
    setPasswordType(passwordType === "password" ? "text" : "password");
  };

  return (
    <div className={styles.wrapper}>
      {phone ? (
        <InputMask
          type="tel"
          format="(###) ### ## ##"
          mask="_"
          alwaysshowmask="true"
          value={value}
          onValueChange={(values) => {
            onChange({
              target: {
                value: values.value,
              },
            });
          }}
          className={inputClasses}
          {...props}
        />
      ) : (
        <input
          type={password && passwordType}
          className={inputClasses}
          value={value}
          onChange={onChange}
          onKeyDown={onKeyDown}
          {...props}
        />
      )}
      {password && (
        <button className={styles.passwordButton} onClick={(e) => showHide(e)}>
          {showHideButton && <span>{passwordType === "password" ? "Göster" : "Gizle"}</span>}
        </button>
      )}
      {errorMessage && <span className={styles.errorMessage}>{errorMessage}</span>}
    </div>
  );
};

Input.propTypes = {
  inputClass: PropTypes.any,
  errorMessage: PropTypes.string,
  password: PropTypes.bool,
  showHideButton: PropTypes.bool,
  phone: PropTypes.bool,
  value: PropTypes.string,
  onChange: PropTypes.func,
  onKeyDown: PropTypes.func,
};

export default Input;
